module.exports = __webpack_public_path__ + "static/media/Sharp_Surveys_Data.8317a7c9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/Sharp_Surveys_Data.csv
// module id = 964
// module chunks = 0